<template>
  <div class="wrap">
    <iframe 
      ref="iframe" 
      :src="htmlSrc" 
      width="100%" 
      height="100%" 
      frameborder="0">
    </iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      htmlSrc:'static/feedback.html', // 注意: 直接写 static ,前面不需要加任何路径和字符。
    };
  },
};
</script>

<style scoped>
.wrap{
  width: 100%;
  height: 1900px;
}
@media screen and (max-width: 768px) {
  .wrap{
    height: 1300px
  }
}
</style>